// Media backgrounds are CSS `background` values: a gradient, or a photo layered
// over one (see photo() in data/seed.js). Emoji art is only drawn when there's no photo.
export const hasPhoto = bg => typeof bg === 'string' && bg.includes('url(');

// A product's first photo, for thumbnails (null when it only has emoji art)
export const productPhoto = product => product?.images?.find(img => hasPhoto(img.bg))?.bg || null;
